module.exports = __webpack_public_path__ + "media/images/form-icon-nav-3fd8f79278bb511532facb0c31da44bd.svg";